import type {
  MasterTimeOffList,
  MasterTimeOffPreview,
  MasterTimeOffRequest,
  MasterTimeOffRequestView,
} from "@planerius/contracts/cabinet"

import { apiRequest } from "./http"

/**
 * «Отпроситься» (5-М6, вариант А): просьба уходит делом в ленту администратора, он сам
 * оформляет отсутствие. Здесь — только свои просьбы мастера.
 */
export function fetchTimeOffRequests(signal?: AbortSignal): Promise<MasterTimeOffList> {
  return apiRequest<MasterTimeOffList>("/cabinet/master/time-off", { signal })
}

export function fetchTimeOffPreview(
  query: { readonly branchId: string; readonly dateFrom: string; readonly dateTo: string },
  signal?: AbortSignal,
): Promise<MasterTimeOffPreview> {
  const params = new URLSearchParams(query)
  return apiRequest<MasterTimeOffPreview>(`/cabinet/master/time-off/preview?${params.toString()}`, { signal })
}

export function requestTimeOff(request: MasterTimeOffRequest): Promise<MasterTimeOffRequestView> {
  return apiRequest<MasterTimeOffRequestView>("/cabinet/master/time-off", { method: "POST", body: request })
}

export function recallTimeOff(requestId: string): Promise<void> {
  return apiRequest(`/cabinet/master/time-off/${requestId}/recall`, { method: "POST" })
}
